
export class APIIntegration {
    static apiToken = ""   

    static setApiToken = (token: string) => {
      this.apiToken = token
    }

    /** @deprecated */
    static getErrorMessage = async (rawResponse: any) => {
      const errorText = await rawResponse.text();
      const errorMessage = `Error: ${rawResponse.status} - ${rawResponse.statusText}. \nDetails: ${errorText}`;
      return errorMessage
    }

}

class APIConfig {
    private env: string;
    private shouldUseLocalAPI: boolean;

    constructor() {
        // this.env = "PROD";
      this.env = process.env.REACT_APP_FRONT_ENV || 'PROD';
      this.shouldUseLocalAPI = process.env.REACT_APP_USE_LOCAL_API == "YES" ? true : false
      console.log('APIConfig', this.env)
    }
  
    get baseURL() {
        if (this.shouldUseLocalAPI) {
            return 'http://localhost:8080';
        }
        switch (this.env) {
            case 'PROD':
                return 'https://api.qeeptouch.com';
            case 'QA':
                return 'https://qa-api.qeeptouch.com';
            case 'LOCAL':
                return 'http://localhost:8080';
            default:
                return 'https://api.qeeptouch.com';
      }
    }

    // App-link host the Qontact Auth app registers (qontact-android-auth
    // AppConfig.DEEP_LINK_HOSTS); the host also selects the app's API environment.
    // Without the app installed, the URL lands on qontact-web-auth, which
    // redirects to the store.
    get appQRbaseUrl() {
      switch (this.env) {
        case 'QA':
          return 'https://qa-auth.qontact.com.ar';
        default:
          return 'https://auth.qontact.com.ar';
      }
    }

    // QontactPoint check-in link the app's DeepLinkParser routes to a
    // conversation pinned to that point: https://<auth-host>/qp/<QP-ID>.
    appQRPayload(qontactPointId: string) {
      return `${this.appQRbaseUrl}/qp/${encodeURIComponent(qontactPointId)}`;
    }

    get waQRbaseUrl() {
      switch (this.env) {
        case 'PROD':
          return 'https://wa.me/5491157657668';
        case 'QA':
          return 'https://wa.me/5491151169134';
        case 'LOCAL':
          return 'https://wa.me/5491157657668';
        default:
          return 'https://wa.me/5491157657668';
      }
    }
}

export const apiConfig = new APIConfig();